import React from 'react';

import { Link } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

interface StickyMenuButtonProps {
  className?: string;
  dataTestId?: string;
  disabled?: boolean;
  error?: boolean;
  icon: React.ReactNode;
  onClick: () => void;
  text: string;
}

const StickyMenuButton: React.FC<StickyMenuButtonProps> = ({
  text,
  icon,
  error,
  onClick,
  className,
  dataTestId,
  disabled = false,
}) => (
  <Link
    className={cn(
      'flex! items-center! gap-3! p-0! font-medium!',
      disabled
        ? 'text-disabled-contrast! dark:text-disabled-contrast! pointer-events-none! cursor-not-allowed! opacity-50!'
        : error
          ? 'text-feedback-error-base!'
          : 'text-brand-navy! dark:text-contrast!',
      className,
    )}
    variant="standalone"
    data-testid={dataTestId ?? 'StickyMenuItem'}
    aria-disabled={disabled || undefined}
    onClick={disabled ? undefined : onClick}
  >
    {icon}
    {text}
  </Link>
);

export default StickyMenuButton;
